import styled, { css } from 'styled-components';

export const Div = styled.div<{ $isChecked: boolean; $indeterminate?: boolean; $disabled?: boolean }>`
  height: 24px;
  width: 24px;
  border: 2px solid ${({ theme }) => theme.colors.gp1};
  /* background: ${({ theme }) => theme.colors.white}; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.btnWhite};
    font-size: 16px;
  }

  ${({ $isChecked, $indeterminate }) =>
    ($isChecked || $indeterminate) &&
    css`
      border: none;
      background: ${({ theme }) => theme.colors.gradient};
    `};

  ${({ $disabled, $isChecked, $indeterminate, theme }) =>
    $disabled &&
    css`
      background: ${theme.colors.cflowerBlue};
      cursor: default;
      border: 2px solid ${theme.colors.cflowerBlue};
      background: ${$isChecked || $indeterminate ? theme.colors.cflowerBlue : 'transparent'};
    `};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 20px;
    width: 20px;
  }
`;
